import { Component } from '@angular/core';
import { BentoAlertItemOptions } from '@bento/bento-ng';

@Component({
	selector: 'app-bento-alert-ng',
	templateUrl: './bento-alert-ng.component.html',
	styleUrls: ['./bento-alert-ng.component.css']
})
export class BentoAlertNgComponent {
	alerts: BentoAlertItemOptions[] = [];
	constructor() { }

	closeAlert($event) {
		console.log('Alert #', $event, ' is being closed');
	}

	addAlert() {
		const type = this._getAlertType();
		this.alerts.push({
			type,
			msg      : 'Bento NG ' + type + ' message, with a <a href=\"#/components/alert\">relevant link</a>.',
			closeable: true
		});
	}

	public _getAlertType() {
		const alertTypes: string[] = ['danger', 'warning', 'info', 'success'];
		const index                = Math.floor(Math.random() * 3.99);
		return alertTypes[index];
	}
}
